import React, { useContext, useState } from 'react';
import { AppContext } from '../context/AppContext';

export default function ReviewSummary({ onApprove, onReject }) {
  const { appState, updateState } = useContext(AppContext);
  const resumo = appState.resumo;
  const [topicos, setTopicos] = useState(resumo?.topicos || []);
  const [novoTopico, setNovoTopico] = useState('');

  if (!resumo) return <div>Carregando...</div>;

  const removerTopico = (idx) => {
    const novo = topicos.filter((_, i) => i !== idx);
    setTopicos(novo);
    updateState({ topicos: novo });
  };

  const adicionarTopico = () => {
    if (!novoTopico.trim()) return;
    const novo = [...topicos, novoTopico.trim()];
    setTopicos(novo);
    updateState({ topicos: novo });
    setNovoTopico('');
  };

  const confirmar = () => {
    updateState({ topicos });
    onApprove();
  };

  return (
    <div className="step-content">
      <div className="card">
        <h3>🔍 {resumo.titulo}</h3>
        <p style={{ color: '#555', fontSize: '0.95rem', marginTop: 8, marginBottom: 20 }}>
          A IA identificou os tópicos abaixo a partir do seu material. Eles serão usados para buscar atualizações científicas no PubMed e Google Scholar. Remova os que não forem relevantes ou adicione novos.
        </p>

        <h4 style={{ marginBottom: 12 }}>Tópicos para busca científica:</h4>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
          {topicos.map((topico, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: 'linear-gradient(90deg, #eaf2fb, #f5f5f5)',
              borderLeft: '4px solid #385e81',
              borderRadius: 6,
              padding: '10px 14px'
            }}>
              <span style={{ fontSize: '0.95rem', color: '#1a1a1a' }}>
                🔬 {topico}
              </span>
              <button
                onClick={() => removerTopico(idx)}
                title="Remover tópico"
                style={{
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: '#be1621', fontSize: '1.1rem', padding: '0 4px'
                }}
              >✕</button>
            </div>
          ))}
        </div>

        {/* Adicionar tópico manualmente */}
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <input
            type="text"
            value={novoTopico}
            onChange={e => setNovoTopico(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && adicionarTopico()}
            placeholder="Adicionar tópico manualmente..."
            className="input"
            style={{ flex: 1 }}
          />
          <button onClick={adicionarTopico} className="btn btn-secondary" style={{ whiteSpace: 'nowrap' }}>
            + Adicionar
          </button>
        </div>

        <p style={{ fontSize: '0.8rem', color: '#888', marginTop: 8 }}>
          {topicos.length} tópico(s) selecionado(s) para busca
        </p>
      </div>

      <div className="button-group">
        <button onClick={onReject} className="btn btn-secondary">
          ❌ Voltar e tentar novamente
        </button>
        <button
          onClick={confirmar}
          className="btn btn-primary"
          disabled={topicos.length === 0}
        >
          ✅ Confirmar e buscar atualizações
        </button>
      </div>
    </div>
  );
}
